import { FilmstripBoxMultipleIcon } from './FilmstripBoxMultipleIcon';

/**
 * author: Google
 * id 392DCBD5-0766-4719-B198-42A9A66C18B4
 * name filmstrip-box-multiple
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filmstrip-box-multiple.svg
 * tags
 * - Video / Movie 
 */
export const LibraryMovieIcon = FilmstripBoxMultipleIcon;
export default LibraryMovieIcon